export const productInitList = [
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0382618092698',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN0194INxZ1DRbLzq24Kf_!!2214056680213-0-cib.jpg',
    subject: '宠物双头遛狗绳一拖二牵引绳防缠绕渐变狗链子狗狗牵引绳宠物用品',
    subjectTrans: 'Pet Double-headed Dog Walking Rope One-to-Two Traction Rope Anti-winding Gradient Dog Chain Dog Traction Rope Pet Supplies',
    priceInfo: {
      price: '13.08'
    },
    monthSold: 102,
    minOrderQuantity: 1,
    tradeScore: '4.9',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.68'
    },
    categoryId: '121802003'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0471882027242',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01JjXKtI2ErzsbUkykU_!!2215671228799-0-cib.jpg',
    subject: '跨境小型宝马暖风机迷你热风扇速热电暖器portable heater取暖器',
    subjectTrans: 'Cross-border small BMW heater mini hot fan quick heating electric heater portable heater heater',
    priceInfo: {
      price: '29.23'
    },
    monthSold: 123,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.55'
    },
    categoryId: '1047984'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0957164010662',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01HysySM1tShzmSETYW_!!1072655901-0-cib.jpg',
    subject: '儿童童裤春秋季女童打底裤女童裤批发代发宝宝打底裤女童a类',
    subjectTrans: "Children's pants spring and autumn girls' leggings girls' pants wholesale generation baby leggings girls category a",
    priceInfo: {
      price: '24.00'
    },
    monthSold: 2128,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.77'
    },
    categoryId: '127430003'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0191323562804',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01IZ0km01nr5OGpuqke_!!2212841575142-0-cib.jpg',
    subject: '跨境 外贸 中性款项链嘻哈哥特式朋克风格带刺铁丝小荆棘链条',
    subjectTrans: 'Cross-border Trade Neutral Necklace Hip-hop Gothic Punk Style Small Thorns Chain with barbed wire',
    priceInfo: {
      price: '3.71'
    },
    monthSold: 0,
    minOrderQuantity: 1,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '2.00',
      repeatPurchasePercent: '0.50'
    },
    categoryId: '1037275'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0780059321732',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01q5E79p1OvKsAtqhrn_!!2218970081767-0-cib.jpg',
    subject: '便携式运动水杯健身塑料蛋白粉水壶可定刻度LOGO摇摇杯奶昔搅拌',
    subjectTrans: 'Portable Sports Cup Fitness Plastic Protein Powder Kettle Fixed Scale LOGO Shake Cup Milkshake Stir',
    priceInfo: {
      price: '5.69'
    },
    monthSold: 355,
    minOrderQuantity: 2,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '1',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.60'
    },
    categoryId: '1046723'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0474629788585',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01ICoNEi1DSyRY5pwCc_!!2208139590216-0-cib.jpg',
    subject: '手机补光灯拍摄直播补光灯自拍灯神器便携美颜灯主播摄影灯打光灯',
    subjectTrans: 'Mobile phone fill light shooting live fill light self-timer light artifact portable beauty light anchor photography light lighting light',
    priceInfo: {
      price: '73.85'
    },
    monthSold: 399,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.65'
    },
    categoryId: '124736050'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0465170858121',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01r3n4ov1jj3qC7kZYT_!!4148184583-0-cib.jpg',
    subject: '可爱迷你指尖扑克牌儿童卡片扑克旅行桌游纸牌袖珍便携扑克牌',
    subjectTrans: "Cute Mini Fingertip Playing Cards Children's Card Poker Travel Table Game Cards Pocket Portable Playing Cards",
    priceInfo: {
      price: '1.12'
    },
    monthSold: 114,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.64'
    },
    categoryId: '124744034'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0389795647774',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01RPLXti24MGNM8bEUX_!!2218590397376-0-cib.jpg',
    subject: '高品质德训二代休闲男鞋女鞋百搭运动板帆布鞋',
    subjectTrans: "high quality Desun Second Generation Casual Men's Shoes Women's Shoes All-match Sports Board Canvas Shoes",
    priceInfo: {
      price: '212.31'
    },
    monthSold: 946,
    minOrderQuantity: 1,
    tradeScore: '4.7',
    sellerDataInfo: null,
    categoryId: '126442003'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0090422409904',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01hJ0N2u2Bg8vUGkoJK_!!2214123838367-0-cib.jpg',
    subject: '32OZ运动水壶三指盖太空壶大容量304不锈钢保温杯提手杯现货批发',
    subjectTrans: '32oz Sports Water Bottle Three-Finger Lid Space Bottle Large Capacity 304 Stainless Steel Thermos Cup Handle Cup Ready for Sale',
    priceInfo: {
      price: '30.00'
    },
    monthSold: 1500,
    minOrderQuantity: 25,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.48'
    },
    categoryId: '1043766'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0966194539313',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01v82PRv29MKVhHzYFN_!!2209079728053-0-cib.jpg',
    subject: '跨境PU皮革撞色拼接印花章仔立领拉链长袖修身短款潮流机车夹克女',
    subjectTrans: 'Cross-border PU leather color contrast stitching printing Zhang Zi stand collar zipper long sleeve slim-fit short trend motorcycle jacket women',
    priceInfo: {
      price: '65.85'
    },
    monthSold: 0,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.54'
    },
    categoryId: '125750002'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0091036352551',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01CAVboA1ttHCGGNu5M_!!2214734035959-0-cib.jpg',
    subject: '跨境双层真空304不锈钢保温杯便携式提环运动水杯户外随手杯批发',
    subjectTrans: 'Cross-border double-layer vacuum 304 stainless steel thermos cup portable lifting ring sports cup outdoor casual cup wholesale',
    priceInfo: {
      price: '23.02'
    },
    monthSold: 0,
    minOrderQuantity: 5,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '4.00',
      repeatPurchasePercent: '0.64'
    },
    categoryId: '1043766'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0193376896071',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01Addmen1sXuwHeUgM8_!!2206689295777-0-cib.jpg',
    subject: '跨境304不锈钢14oz马克杯迷你便携真空咖啡杯办公室手柄杯礼品杯',
    subjectTrans: 'Cross Border 304 Stainless Steel 14oz Mug Mini Portable Vacuum Coffee Cup Office Handle Cup Gift Cup',
    priceInfo: {
      price: '20.77'
    },
    monthSold: 0,
    minOrderQuantity: 1,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '0',
      disputeComplaintScore: '0',
      offerExperienceScore: '0',
      repeatPurchasePercent: '0.42'
    },
    categoryId: '1043766'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0389801480832',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN0117DZDy1NIZhx3X519_!!2218469571547-0-cib.jpg',
    subject: '莆田aj1男鞋倒钩金丝雀正品sb联名低帮闪电白蓝白棕板鞋女跑步鞋',
    subjectTrans: "Putian aj1 men's shoes barb canary genuine goods sb joint low-top lightning white blue white brown shoes women's running shoes",
    priceInfo: {
      price: '135.38'
    },
    monthSold: 255,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '1',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '2.00',
      repeatPurchasePercent: '0.40'
    },
    categoryId: '126442003'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0879837383693',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01BkOCmj1NnigXE3lkK_!!2074121615-0-cib.jpg',
    subject: '跨境欧美饰品夏威夷度假沙滩贝壳项链海洋贝壳双层叠戴项链锁骨链',
    subjectTrans: 'Cross-border European and American Jewelry Hawaii Holiday Beach Shell Necklace Marine Shell Double Layer Overlapping Necklace Clavicle Chain',
    priceInfo: {
      price: '3.69'
    },
    monthSold: 23851,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '5.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '4.00',
      repeatPurchasePercent: '0.70'
    },
    categoryId: '1037275'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0860242774071',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01slKOdc1It9A42uwPZ_!!2214582700950-0-cib.jpg',
    subject: '搪胶大号涂色DIY玩具非石膏娃娃白胚批发史迪仔摆地摊上色存钱罐',
    subjectTrans: 'Vinyl Large Color DIY Toys Non-Plaster Doll White Embryo Wholesale Stall Stall Color Piggy Bank',
    priceInfo: {
      price: '2.15'
    },
    monthSold: 6318,
    minOrderQuantity: 3,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.89'
    },
    categoryId: '122986008'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0689614635636',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01yRX79e1wJxU6cwyHS_!!2211887516288-0-cib.jpg',
    subject: '「飞鸟诗集」秋冬蓝色小鸟项链复古可爱小众设计感手工百搭毛衣链',
    subjectTrans: '"Bird Poetry Collection" Autumn and Winter Blue Bird Necklace Retro Cute Niche Design Handmade All-match Woolen Chain',
    priceInfo: {
      price: '3.23'
    },
    monthSold: 2421,
    minOrderQuantity: 1,
    tradeScore: '4.8',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.64'
    },
    categoryId: '1037275'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0971351235253',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01N38nnB23hxTwyrqNB_!!2868257288-0-cib.jpg',
    subject: '脸部按摩轮檀木滚轮脸部滚动提拉工具紧致脸按摩棒揉捏下颚拔筋棒',
    subjectTrans: 'Face Massage Wheel Sandalwood Roller Face Rolling Lift Tool Tighten Face Massage Stick Kneading Lower Jaw Pull Bar',
    priceInfo: {
      price: '6.92'
    },
    monthSold: 4765,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.56'
    },
    categoryId: '123696002'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0495432632923',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01xJXT7A1ukrYz6BQSN_!!2818306076-0-cib.jpg',
    subject: '跨境304不锈钢保温杯30oz车载汽车杯保冷吸管冰霸杯手提便携户外',
    subjectTrans: 'Cross-Border 304 Stainless Steel Insulated Cup 30oz Car Cup with Straw for Keeping Cold, Portable Outdoor',
    priceInfo: {
      price: '27.38'
    },
    monthSold: 100,
    minOrderQuantity: 2,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.50'
    },
    categoryId: '1043766'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0581584629205',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01hx5LnM1XV4gyZFDqw_!!2218857802928-0-cib.jpg',
    subject: '欧美风气质时尚腊肠狗吊坠耳环项链套装简约可爱动物锁骨链女批发',
    subjectTrans: 'European and American style temperament fashion dachshund dog pendant earrings necklace suit simple cute animal clavicle chain women wholesale',
    priceInfo: {
      price: '16.15'
    },
    monthSold: 409,
    minOrderQuantity: 1,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '1',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.70'
    },
    categoryId: '1746'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0086597335856',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01BfjjeO1n1KmJoEnXF_!!2528805029-0-cib.jpg',
    subject: '书法励志文字钥匙扣 高颜值国风diy挂饰学生亚克力包包装饰小挂件',
    subjectTrans: 'Calligraphy inspirational text key chain high color value national style diy pendant student acrylic bag decorative small pendant',
    priceInfo: {
      price: '0.57'
    },
    monthSold: 31962,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '5.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '4.00',
      repeatPurchasePercent: '0.79'
    },
    categoryId: '10340'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0974901023855',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01hsyqDK1nTjKWu1Tvm_!!2215713335091-0-cib.jpg',
    subject: '跨境男鞋2025夏季阿甘鞋潮流休闲透气懒人开车防滑无后跟半托板鞋',
    subjectTrans: "Cross-border Men's Shoes 2025 Summer Forrest Gump Shoes Trendy Casual Breathable Lazy Driving Non-slip Heatless Half Board Shoes",
    priceInfo: {
      price: '26.15'
    },
    monthSold: 118,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: null,
    categoryId: '126442003'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0867863723065',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01PNOEMf2K4QimlEGxD_!!2214906049503-0-cib.jpg',
    subject: 'Sumifun 速卖通亚马逊私密处阴痒膏20G皮肤膏药软膏外用 K10022',
    subjectTrans: 'Sumifun AliExpress Amazon Secret Yin Itch Ointment 20G Skin Plaster Ointment K10022 for Topical Use',
    priceInfo: {
      price: '4.62'
    },
    monthSold: 21322,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.55'
    },
    categoryId: '10532'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0875071099511',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN019gRo9e1UZFO2T6HoG_!!2206747162531-0-cib.jpg',
    subject: '儿童运动发带中国红头带加油必胜街舞篮球表演运动会入场头饰批发',
    subjectTrans: "Children's Sports Hair Band China Red Headband Refueling Win Street Dance Basketball Show Games Entrance Headwear Wholesale",
    priceInfo: {
      price: '0.77'
    },
    monthSold: 79733,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.66'
    },
    categoryId: '1037264'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0168741038773',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/19475031218_1160598059.jpg',
    subject: '骑行面罩男女防风防尘自行车装备防寒保暖面罩半脸跑步透气活性炭',
    subjectTrans: 'Cycling mask men and women windproof dustproof bicycle equipment cold-proof warm mask half face running breathable activated carbon',
    priceInfo: {
      price: '6.15'
    },
    monthSold: 5906,
    minOrderQuantity: 1,
    tradeScore: '4.5',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.69'
    },
    categoryId: '122102003'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0571881208257',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN015NxAb71FWIfyXgBRS_!!2207216460494-0-cib.jpg',
    subject: '彩色纹身贴纸爱国主题防水持久可洗元旦新年国庆双十一节日运动会',
    subjectTrans: "Color Tattoo stickers patriotic theme waterproof durable washable New Year's day National Day Double Eleven Festival sports meeting",
    priceInfo: {
      price: '0.77'
    },
    monthSold: 41150,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '4.00',
      repeatPurchasePercent: '0.81'
    },
    categoryId: '124278005'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0289753611665',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01kf4RLx1k00o8VtpiS_!!2216152464620-0-cib.jpg',
    subject: '新中式平安锁项链女复古国潮轻奢小众新款爆款设计感百搭颈链',
    subjectTrans: "New Chinese Style Safe Lock Necklace Women's Retro National Fashion Light Luxury Niche New Explosive Design All-match Necklace",
    priceInfo: {
      price: '0.77'
    },
    monthSold: 8740,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '3.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '2.00',
      repeatPurchasePercent: '0.52'
    },
    categoryId: '1037275'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0667505169730',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/9249351091_1793412859.jpg',
    subject: '外贸跨境细皮带女士手表经典数字多色学生潮流石英表开学专款批发',
    subjectTrans: 'Foreign trade cross-border thin belt ladies watch classic digital multi-color Student trend quartz watch opening special Wholesale',
    priceInfo: {
      price: '9.08'
    },
    monthSold: 32,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '3.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.66'
    },
    categoryId: '124264005'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0190411588780',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01zk50wP1fQVasVufkP_!!2559594001-0-cib.jpg',
    subject: '跨境现货304不锈钢真空10oz汽车杯热升华 喷塑马克咖啡杯保温水杯',
    subjectTrans: 'Cross-border in stock 304 stainless steel vacuum 10oz car cup sublimation plastic spray mark coffee cup insulation water cup',
    priceInfo: {
      price: '22.77'
    },
    monthSold: 0,
    minOrderQuantity: 2,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '2.00',
      repeatPurchasePercent: '0.42'
    },
    categoryId: '1043766'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0197368794651',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN012XY9dZ2IY5EvqJlVR_!!3971809297-0-cib.jpg',
    subject: '欧美时尚复古潮流花卉项链跨境森系少女花朵耳环新款外贸首饰套装',
    subjectTrans: 'European and American fashion retro trend flower necklace cross-border forest girl flower earrings new foreign trade jewelry suit',
    priceInfo: {
      price: '10.46'
    },
    monthSold: 10,
    minOrderQuantity: 1,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '3.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '2.00',
      repeatPurchasePercent: '0.48'
    },
    categoryId: '1746'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0672613974732',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01LrPKsQ1zAkGb9Iehm_!!3410136674-0-cib.jpg',
    subject: '2025新款lulu同款手腕包便携式露露卡包银行卡迷你零钱收纳包小包',
    subjectTrans: '2024 New lulu same wrist bag portable lulu card holder bank card mini change storage bag',
    priceInfo: {
      price: '24.62'
    },
    monthSold: 9298,
    minOrderQuantity: 3,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '4.00',
      repeatPurchasePercent: '0.68'
    },
    categoryId: '121900001'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0767816790226',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01Md7M581FnF5432YA2_!!2213085040531-0-cib.jpg',
    subject: '春夏季华夫格浴袍女士桑拿服薄款汗蒸服睡袍男士吸水速干浴衣批发',
    subjectTrans: "Spring and summer waffle bathrobe ladies sauna clothes thin sweat steaming dressing gown men's absorbent quick-drying bathrobe wholesale",
    priceInfo: {
      price: '40.00'
    },
    monthSold: 19697,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '5.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.63'
    },
    categoryId: '122454002'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0683234782467',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01Tuo0vE1ynqKp66MRI_!!1988846624-0-cib.jpg',
    subject: '2022时尚水晶水钻 项链耳钉手链三件套首饰配件 婚礼饰品百搭新娘',
    subjectTrans: '2022 Fashion Crystal Rhinestone Necklace Earrings Bracelet Three-piece Jewelry Accessories Wedding Accessories All-match Bride',
    priceInfo: {
      price: '17.69'
    },
    monthSold: 10,
    minOrderQuantity: 1,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '3.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '2.00',
      repeatPurchasePercent: '0.50'
    },
    categoryId: '1746'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0191225910761',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN013HFODD1fqc0sCg3m0_!!2212485574058-0-cib.jpg',
    subject: '2024春季新款休闲男鞋户外运动板鞋学生小白鞋韩版时尚潮鞋男低帮',
    subjectTrans: "2024 Spring New Casual Men's Shoes Outdoor Sports Shoes Student White Shoes Korean Style Fashion Shoes Men's Low Tops",
    priceInfo: {
      price: '30.75'
    },
    monthSold: 0,
    minOrderQuantity: 2,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '3.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '0.00',
      repeatPurchasePercent: '0.47'
    },
    categoryId: '126442003'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0779460632464',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01WffxjT1Zb96CkagDq_!!2210925573212-0-cib.jpg',
    subject: '跨境热销越南爆款90码摇奖机bingo宾果中奖机桌面玩具',
    subjectTrans: 'Cross-border hot selling Vietnam popular 90-yard lottery machine bingo winning machine desktop toys',
    priceInfo: {
      price: '29.23'
    },
    monthSold: 103,
    minOrderQuantity: 1,
    tradeScore: '1.0',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.50'
    },
    categoryId: '124744034'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0171526626450',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01trXaHS1jvt5s9PnYD_!!2215703004611-0-cib.jpg',
    subject: '新大口双饮杯提手汽车保温杯304不锈钢礼品杯便携车载 可制定LOGO',
    subjectTrans: 'New big mouth double drink cup handle car thermos cup 304 stainless steel gift Cup portable car LOGO',
    priceInfo: {
      price: '19.23'
    },
    monthSold: 355,
    minOrderQuantity: 2,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '2.00',
      repeatPurchasePercent: '0.70'
    },
    categoryId: '1043766'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0582326837985',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01DNtZ8Q1c0SFp6jVSC_!!2863603538-0-cib.jpg',
    subject: '跨境新款收纳袋挂脖悬挂蓝牙耳机眼镜钥匙皮质便携式酷风包包项链',
    subjectTrans: 'Cross-border New Storage Bag Hanging Neck Bluetooth Headset Glasses Key Leather Portable Cool Wind Bag Necklace',
    priceInfo: {
      price: '5.85'
    },
    monthSold: 3,
    minOrderQuantity: 1,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '0',
      disputeComplaintScore: '0',
      offerExperienceScore: '0',
      repeatPurchasePercent: '0.50'
    },
    categoryId: '1037275'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0292102751759',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01qBITdj267j55rom2a_!!2219402297615-0-cib.jpg',
    subject: '莆田鞋 pm Suede XL面包鞋男女款德训鞋厚底防滑耐磨运动低帮板鞋',
    subjectTrans: "Putian Shoes Pm Suede XL Bread Shoes Men's and Women's Moral Training Shoes Thick-Soled Non-Slip Wear-Resistant Sports Low-Cut Sneakers",
    priceInfo: {
      price: '210.77'
    },
    monthSold: 4,
    minOrderQuantity: 1,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '3.50',
      disputeComplaintScore: '3.00',
      offerExperienceScore: '2.00',
      repeatPurchasePercent: '0.28'
    },
    categoryId: '126442003'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0683149995006',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01LCkfIc1I7W5ewKkhw_!!2720260846-0-cib.jpg',
    subject: '欧美时尚套装饰品个性女水钻骷髅头项链个性万圣节佩跨境爆款',
    subjectTrans: 'European and American fashion skull suit jewelry personality female rhinestone necklace earrings Halloween wear jewelry factory wholesale',
    priceInfo: {
      price: '11.23'
    },
    monthSold: 14,
    minOrderQuantity: 3,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.58'
    },
    categoryId: '1746'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0275295265963',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN013KXvwo1DqKc8PgxNA_!!2214620260267-0-cib.jpg',
    subject: '儿童画板磁性画画板玩具宝宝写字板家用涂鸦板磁力彩色绘画架画桌',
    subjectTrans: "Children's Drawing Board Magnetic Drawing Board Toy Baby's Writing Board Home Doodle Board Magnetic Color Painting Frame Picture Table",
    priceInfo: {
      price: '10.00'
    },
    monthSold: 1173,
    minOrderQuantity: 1,
    tradeScore: '4.8',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '4.00',
      repeatPurchasePercent: '0.45'
    },
    categoryId: '123752006'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0287628876694',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01IbnXsl2IFIy4tAZQr_!!2218490589256-0-cib.jpg',
    subject: '纯羊毛衫秋冬款高领中大儿童毛线衣男女童打底针织衫宝宝简约毛衣',
    subjectTrans: "Pure Wool Sweater Autumn and Winter High Collar Large Children's Sweater Boys' and Children's Bottoming Sweater Baby Simple Sweater",
    priceInfo: {
      price: '116.92'
    },
    monthSold: 6,
    minOrderQuantity: 1,
    tradeScore: '4.7',
    sellerDataInfo: {
      tradeMedalLevel: '1',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.51'
    },
    categoryId: '1037010'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0760084834460',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01dyLxC421uCw5JTR7W_!!2815757044-0-cib.jpg',
    subject: '跨境狗狗牵引绳防爆冲大狗胸背带反光大型犬狗绳背心式户外遛狗绳',
    subjectTrans: 'Cross-border Dog Traction Rope Explosion-proof Chong Big Dog Chest Strap Reflective Large Dog Rope Vest Outdoor Dog Walking Rope',
    priceInfo: {
      price: '25.85'
    },
    monthSold: 9359,
    minOrderQuantity: 3,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.72'
    },
    categoryId: '121802003'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0973954095544',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01qZ9hhX2DGc0G6dMfR_!!2206719808582-0-cib.jpg',
    subject: '厂家直销不锈钢链条男百搭DIY基础链工厂直销跨境锁骨链吊坠配饰',
    subjectTrans: "Factory direct stainless steel chain men's Joker DIY basic chain factory direct cross-border clavicle chain pendant accessories",
    priceInfo: {
      price: '1.35'
    },
    monthSold: 21675,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '2.00',
      repeatPurchasePercent: '0.69'
    },
    categoryId: '1037275'
  },
  {
    ext: {
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0677056007124',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01AzAhst1Zy2ufNWnhc_!!3909853262-0-cib.jpg',
    subject: '亚马逊新款百搭休闲pu女包简约高级感单肩包大容量宽肩带斜挎包潮',
    subjectTrans: "Amazon new all-match casual pu women's bag simple high-grade shoulder bag large capacity wide shoulder strap messenger bag fashion",
    priceInfo: {
      price: '41.54'
    },
    monthSold: 5103,
    minOrderQuantity: 3,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.66'
    },
    categoryId: '201554511'
  },
  {
    ext: {
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0588653192553',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01Xhp4uJ1OYtSCN3VbK_!!2212938271718-0-cib.jpg',
    subject: '手掌杯内衣女小胸聚拢显大固定杯无钢圈防下垂上托无痕文胸舒适',
    subjectTrans: "Palm-style Soft Support Underwear Women's Small Chest Push-up Large Fixed Cup No-steel Ring Anti-sagging Upper Support No-trace Bra",
    priceInfo: {
      price: '26.92'
    },
    monthSold: 43,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.65'
    },
    categoryId: '124196008'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0680953806591',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01dHe26e25OqFbUpT37_!!2207936337517-0-cib.jpg',
    subject: '跨境厂家直供不锈钢保温杯大容量磨砂户外高颜值随手杯双层吸管杯',
    subjectTrans: 'Cross-border factory direct supply stainless steel thermos cup large capacity frosted outdoor high color value cup double-layer suction tube cup',
    priceInfo: {
      price: '38.46'
    },
    monthSold: 462,
    minOrderQuantity: 2,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '5.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.74'
    },
    categoryId: '1043766'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0178417592515',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01a5Rxra2Iz6QXsVpVW_!!2213317019356-0-cib.jpg',
    subject: '欧美时尚轻奢复古满钻星星项链手链钛钢金属小众百搭简约首饰套装',
    subjectTrans: 'European and American fashion light luxury vintage diamond star necklace bracelet titanium steel metal niche all-match simple jewelry suit',
    priceInfo: {
      price: '13.08'
    },
    monthSold: 1070,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '5.00',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.69'
    },
    categoryId: '1746'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0280826722982',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01J3023b1GkKO3uKjD3_!!2214219100660-0-cib.jpg',
    subject: '新款梵高保温杯咖啡杯女生杯子高颜值礼物双饮不锈钢吸管杯水杯',
    subjectTrans: 'New Van Gogh Thermos Cup Coffee Cup Girls Cup High Color Value Gift Double Drink Stainless Steel Suction Cup Water Cup',
    priceInfo: {
      price: '41.54'
    },
    monthSold: 1221,
    minOrderQuantity: 1,
    tradeScore: '4.9',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '5.00',
      repeatPurchasePercent: '0.79'
    },
    categoryId: '1043766'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0982666312085',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01ZDZjy41fqc5EA3tRL_!!2212485574058-0-cib.jpg',
    subject: '透气网鞋子男士潮流百搭小白鞋学生运动休闲板鞋潮鞋2025夏季新款',
    subjectTrans: "Breathable Mesh Shoes Men's Trendy All-match White Shoes Student Sports Casual Sneakers Trendy Shoes 2025 Summer New",
    priceInfo: {
      price: '29.23'
    },
    monthSold: 585,
    minOrderQuantity: 1,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '4.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.56'
    },
    categoryId: '126442003'
  },
  {
    ext: {
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0493789318462',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01NIsmNV2Kp9BY8Ou2K_!!2217538929605-0-cib.jpg',
    subject: '西太后项链女薇薇安土星珍珠别针回形针同款吊坠星球欧美工厂批发',
    subjectTrans: 'Empress Necklace for Women Vivian Saturn Pearl Pin Paperclip Same Style Pendant Planet European and American Factory Wholesale',
    priceInfo: {
      price: '38.46'
    },
    monthSold: 0,
    minOrderQuantity: 1,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '0',
      disputeComplaintScore: '0',
      offerExperienceScore: '0',
      repeatPurchasePercent: '0.42'
    },
    categoryId: '1037275'
  },
  {
    ext: {
      RECALL: 'RecommendProductShortTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2',
      FILTER: null
    },
    offerId: '0880933021928',
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN011jDv2n1pvKVFM9s8b_!!3340425422-0-cib.jpg',
    subject: '跨境欧美热销金色锌合金镂空绿色树脂水钻项链耳环套装女饰品首饰',
    subjectTrans: 'Cross-border European and American Hot Selling Gold Zinc Alloy Hollow Green Resin Rhinestone Necklace Earrings suit Women Jewelry',
    priceInfo: {
      price: '24.31'
    },
    monthSold: 440,
    minOrderQuantity: 1,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.50',
      disputeComplaintScore: '5.00',
      offerExperienceScore: '3.00',
      repeatPurchasePercent: '0.59'
    },
    categoryId: '1746'
  }
]
